let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iI3rq")).then(() => parcelRequire('65XvS'));